/* HDC Aktionsleiste: Countdown (aus HDC Rollrasen-Herbst übernommen) und wechselnde Botschaften. */
(function () {
  if (window.hdcAnnouncement) return;
  window.hdcAnnouncement = true;
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function set(root, k, v) { root.querySelectorAll('[data-cd="' + k + '"]').forEach(function (el) { if (el.textContent !== String(v)) el.textContent = v; }); }
  function tick() {
    var now = Date.now();
    document.querySelectorAll('[data-hdc-deadline]').forEach(function (el) {
      var diff = new Date(el.getAttribute('data-hdc-deadline')).getTime() - now;
      if (!(diff > 0)) { var w = el.closest('[data-hdc-expire]') || el; w.hidden = true; return; }
      var s = Math.floor(diff / 1000);
      set(el, 'd', Math.floor(s / 86400)); set(el, 'h', pad(Math.floor((s % 86400) / 3600)));
      set(el, 'm', pad(Math.floor((s % 3600) / 60))); set(el, 's', pad(s % 60));
    });
  }
  tick(); setInterval(tick, 1000);
  document.addEventListener('shopify:section:load', tick);

  if (!customElements.get('hdc-rotator')) {
    customElements.define('hdc-rotator', class extends HTMLElement {
      connectedCallback() {
        this.items = [...this.children];
        if (this.items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.i = 0;
        var speed = parseInt(this.dataset.speed, 10) || 5000;
        this.timer = setInterval(() => {
          this.items[this.i].classList.remove('is-active');
          this.i = (this.i + 1) % this.items.length;
          this.items[this.i].classList.add('is-active');
        }, speed);
        this.addEventListener('mouseenter', () => clearInterval(this.timer), { once: true });
      }
      disconnectedCallback() { clearInterval(this.timer); }
    });
  }
})();
